import { CEPaymentIntentBase } from './ce-payment-intent-base'


export class CEPaymentIntent extends CEPaymentIntentBase {

}